import React from 'react';
import uuid from 'uuid/v4';
import styled from 'styled-components';
import LargeLabel from '../LargeLabel';
import SmallLabel from '../SmallLabel';
import Date from '../Date';
import Tag from '../Tag';
import UnstyledList from '../UnstyledList';

export const DateCell = (field) => ({ row }) => { // eslint-disable-line
  return row[field] ? <Date date={row[field]} /> : <></>;
};

export const DateTimeCell = (field) => ({ row, format }) => { // eslint-disable-line
  return row[field] ? <Date date={row[field]} format="DD.MM.YYYY HH:mm" /> : <></>;
};


export const SmallLabelCell = (field) => ({ row }) => // eslint-disable-line
  <SmallLabel>{row[field]}</SmallLabel>;

export const LargeLabelCell = (field) => ({ row }) => // eslint-disable-line
  <LargeLabel>{row[field]}</LargeLabel>;

export const SmallLabelListCell = field => ({ row }) => ( // eslint-disable-line
  <UnstyledList>
    {row[field] && row[field].map((value) => (
        <li key={uuid()}><SmallLabel>{value}</SmallLabel></li> // eslint-disable-line
    ))}
  </UnstyledList>
);


const SmallList = styled(UnstyledList)`
  li {
    margin: 0 0 4px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
export const TagListCell = field => ({ row }) => ( // eslint-disable-line
  <SmallList>
    {row[field] && row[field].map((value) => (
      <li key={uuid()}><Tag>{value}</Tag></li>
    ))}
  </SmallList>
);
